type Props = {
  htmlFor: string;
  text: string;
};

const Label = ({ htmlFor, text }: Props) => (
  <label className="text-white mb-2 whitespace-pre-line" htmlFor={htmlFor}>
    {text}
  </label>
);

export default Label;
